import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { ClientNoteViewModel } from "@app/shared/models/clients/ClientNoteViewModel.model";
import { HttpClient } from "@app/shared/services/http/http-client.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-client-note-view-modal",
  templateUrl: "./client-note-view-modal.component.html",
})
export class ClientNoteViewModalComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() note: ClientNoteViewModel | null = null;
  @Input() canEdit: boolean = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();
  @Output() noteSaved = new EventEmitter<ClientNoteViewModel>();

  displayNote: ClientNoteViewModel | null = null;
  saving = false;

  readonly noteTypes = ["General", "Accident", "Breakdown", "Complaint", "Compliment", "Follow-Up"];
  readonly noteStatuses = ["Open", "Resolved", "Closed"];

  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["visible"] && this.visible) {
      this.displayNote = this.note ? { ...this.note } : null;
    }
  }

  closeModal() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }

  saveNote() {
    if (!this.displayNote || !this.displayNote.note?.trim()) {
      this.toastr.warning("Note content is required");
      return;
    }
    this.saving = true;
    this.http.post("api/client/notes/save", this.displayNote).subscribe({
      next: (saved: any) => {
        this.saving = false;
        this.toastr.success("Note saved");
        this.noteSaved.emit(saved);
        this.closeModal();
      },
      error: () => {
        this.saving = false;
        this.toastr.error("Error saving note");
      },
    });
  }
}

